import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import PaymentIcon from "@mui/icons-material/Payment";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import type { AccountTab, AccountTabConfig } from "./accountTypes";

export const ACCOUNT_TAB_PATH_PREFIX = "/my-account";
export const DEFAULT_ACCOUNT_TAB: AccountTab = "clinic";

export const ACCOUNT_TABS: AccountTabConfig[] = [
  {
    id: "clinic",
    label: "Clinic",
    shortLabel: "Clinic",
    icon: BusinessIcon,
    description: "Practice details & branding",
  },
  {
    id: "profile",
    label: "My profile",
    shortLabel: "Profile",
    icon: PersonIcon,
    description: "Your account information",
  },
  {
    id: "subscription",
    label: "Subscription",
    shortLabel: "Plan",
    icon: PaymentIcon,
    description: "Billing & package",
  },
  {
    id: "sms",
    label: "SMS usage",
    shortLabel: "SMS",
    icon: SmsOutlinedIcon,
    description: "Balance & message log",
  },
  {
    id: "storage",
    label: "File storage",
    shortLabel: "Storage",
    icon: StorageOutlinedIcon,
    description: "Usage & media files",
  },
  {
    id: "reports",
    label: "Payment report",
    shortLabel: "Payments",
    icon: AssessmentOutlinedIcon,
    description: "Payment totals & PDF export",
  },
  {
    id: "treatment-reports",
    label: "Treatment report",
    shortLabel: "Treatments",
    icon: LocalHospitalOutlinedIcon,
    description: "Filter by date, detail table & PDF export",
  },
];

export function getAccountTabPath(tab: AccountTab): string {
  return `${ACCOUNT_TAB_PATH_PREFIX}/${tab}`;
}

export function getAccountTabFromPathname(pathname: string): AccountTab {
  const segment = pathname.split("/").filter(Boolean).pop();
  return isAccountTab(segment) ? segment : DEFAULT_ACCOUNT_TAB;
}

export function isAccountTab(value: string | undefined): value is AccountTab {
  return ACCOUNT_TABS.some((tab) => tab.id === value);
}
